module.exports = __webpack_public_path__ + "static/media/in-store-return-1.85c84834.png";